<template>
  <div class="pages">
    <div class="outSideWrapper pages" id="view">
      <div class="longWrapper">
        <!--报名信息填写-->
        <div class="formData">
          <input
            type="text"
            onblur="window.scrollTo(0,0);"
            placeholder="请填写您的姓名"
            v-model="formData.username"
            :readonly="btnStatus == 1"
          />
        </div>
        <div class="formData" style="margin-top: .75rem;" :style="{marginTop:ISIOS? '.75rem' : '.85rem'}">
          <input
            type="number"
            @blur="phoneCheck()"
            placeholder="请填写您的手机号"
            v-model="formData.phone"
            :readonly="btnStatus == 1"
          />
        </div>

        <!--报名信息按钮提交-->
        <div class="submitBtn" @click="submitInfoClick" v-if="btnStatus === 0">
          <img src="../assets/images1/btn1.png" style="width: 6.69rem;height: .65rem">
        </div>

        <div class="submitBtn" @click="ruleStatus = 1" v-if="btnStatus === 1">
          <img src="../assets/images1/btn2.png" style="width: 6.69rem;height: .65rem">
        </div>

        <div class="submitBtn" v-if="btnStatus === 2">
          <img src="../assets/images1/btn3.png" style="width: 6.69rem;height: .65rem">
        </div>

        <!-- animate__animated animate__pulse-->
        <div class="con1" @click="conJump(0)" ref="con1">
          <img src="../assets/images1/con1.png">
          <img src="../assets/images1/txt1.png" class="conBtn animate__animated animate__pulse">
        </div>

        <div class="con1" @click="conJump(1)" ref="con1" style="top: 18.13rem;">
          <img src="../assets/images1/con2.png">
          <img src="../assets/images1/txt2.png" class="conBtn animate__animated animate__pulse" style="width: 2rem;height: .53rem;left: 4rem">
        </div>

        <div class="con1" ref="con1" style="width: 3.94rem;height: 3.52rem;top: 21.33rem;">
          <img src="../assets/images1/con3.png" style="width: 3.94rem;height: 3.52rem">
          <img src="../assets/images1/txt3.png" class="conBtn animate__animated animate__pulse" style="width: 2.25rem;height: .53rem;left: .82rem;top: 2.2rem;">
          <div class="imgWrapper"  @click="conJump(2)"></div>
        </div>

        <div class="con1" ref="con1" style="width: 3.94rem;height: 3.52rem;top: 21.33rem;left: 3.4rem;">
          <img src="../assets/images1/con4.png" style="width: 3.94rem;height: 3.52rem">
          <img src="../assets/images1/txt4.png" class="conBtn animate__animated animate__pulse" style="width: 2.25rem;height: .53rem;left: .82rem;top: 2.2rem;">
          <div class="imgWrapper" @click="conJump(3)"></div>
        </div>

        <div class="con1" ref="con1" style="width: 3.94rem;height: 3.52rem;top: 24.23rem;">
          <img src="../assets/images1/con5.png" style="width: 3.94rem;height: 3.52rem">
          <img src="../assets/images1/txt5.png" class="conBtn animate__animated animate__pulse" style="width: 2.25rem;height: .53rem;left: .82rem;top: 2.2rem;">
          <div class="imgWrapper" @click="conJump(4)"></div>
        </div>

        <div class="con1" ref="con1" style="width: 3.94rem;height: 3.52rem;top: 24.23rem;left: 3.4rem;">
          <img src="../assets/images1/con6.png" style="width: 3.94rem;height: 3.52rem">
          <img src="../assets/images1/txt6.png" class="conBtn animate__animated animate__pulse" style="width: 2.25rem;height: .53rem;left: .82rem;top: 2.2rem;">
          <div class="imgWrapper" @click="conJump(5)"></div>
        </div>

        <div class="con1" @click="conJump(6)" ref="con1" style="top: 27.03rem;">
          <img src="../assets/images1/con7.png">
          <img src="../assets/images1/txt7.png" class="conBtn animate__animated animate__pulse" style="width: 2.88rem;height: .57rem;left: 3.2rem">
        </div>

        <div class="con1" @click="conJump(7)" ref="con1" style="top: 30.1rem;">
          <img src="../assets/images1/con8.png">
          <img src="../assets/images1/txt8.png" class="conBtn animate__animated animate__pulse" style="width: 2.81rem;height: .55rem;left: 3.2rem">
        </div>


        <!--表单信息填写-->
        <div class="formData" style="top:25.4rem" ref="formData">
          <input
            type="number"
            onblur="window.scrollTo(0,0);"
            placeholder="请填写您的购机金额"
            v-model="formData.amount"
          />

          <!--:readonly="btnStatus == 1"-->
          <input
              type="text"
              style="position:absolute;left:1.4rem;top:1.25rem"
              v-model="selectedValue"
              @click="dateShow"
              onblur="window.scrollTo(0,0);"
              placeholder="请填写您的购机时间"
              readonly="true"
          />
        </div>

        <div class="question" @click="xiaopiaoFlag=true">
          <img src="../assets/images/que.png">
        </div>

        <div class="fileWrapper">
          <input
            type="file"
            class="fileChoose"
            ref="fileChoose"
            @change="picUpload($event)"
            capture="camera"
            accept="image/*"
            id="fileAAA"
            :disabled="btn1Status == 1"
          />
          <img src="../assets/images/addPic.png" />
          <div class="fileSelectPicWrapper" v-show="fileShowFlag">
            <img :src="imgUrlDefault" class="fileSelectPic" ref="imgUrlDefault"/>
            <img
              src="../assets/images/delete.png"
              class="deletePic"
              @click="deletePicHandler"
              v-show="btn1Status == 0"
            />
          </div>
          <!--<img :src="imgUrlDefault">-->
        </div>

        <!--第二个报名信息按钮提交-->
        <div
          class="submitBtn"
          style="top: 17.85rem;"
          @click="submitInfo2Click"
          v-if="btn1Status === 0"
        >
          <img src="../assets/images1/btn4.png" style="width: 6.69rem;height: .65rem">
        </div>

        <div
          class="submitBtn submitBtn1"
          style="top: 17.85rem;"
          v-if="btn1Status === 1"
        >
          <img src="../assets/images1/btn7.png" style="width: 6.69rem;height: .65rem">
        </div>

        <div
              class="submitBtn submitBtn1"
              style="top: 17.85rem;"
              v-if="btn1Status === 2"
        >
          <img src="../assets/images1/btn8.png" style="width: 6.69rem;height: .65rem">
        </div>

        <!--点击查看详细活动规则-->
        <div class="ruleBtn" @click="ruleFlag = true" ref="ruleBtn"></div>
      </div>
    </div>

    <!--点击提交后的弹窗2，您已晒单-->
    <div class="submitWindow pages" v-show="ruleStatus == 2">
      <img src="../assets/images1/win1.png" v-if="ruleStatus == 2" />
      <div class="ruleBtn" @click="ruleStatus = 0">
        <img src="../assets/images1/btn5.png" style="width: 3.82rem;height: .89rem;top:.4rem">
      </div>
    </div>

    <!--点击提交后的弹窗1，您已报名-->
    <div class="pages" v-show="ruleStatus == 1" @click.self="ruleStatus = 0">
      <div class="submitWindow pages" id="window" style="overflow: auto">
        <!--:style="KGB?'top: 10%':'top: 0'"-->
        <div style="position: relative">
          <img src="../assets/images1/win2.png" style="width:6.81rem;height: 12.15rem;top: .3rem;" v-if="ruleStatus == 1" />

          <img src="../assets/images/close.png" class="closeBtn" @click.self="ruleStatus = 0">

          <div class="dis">
            <img src="../assets/images1/dis1.png" @click="conJump(8)">
          </div>

          <div class="dis dis1">
            <img src="../assets/images1/dis2.png" @click="conJump(9)">
          </div>

          <div class="con2">
            <img src="../assets/images1/con11.png" @click="conJump(10)">
          </div>
          <div class="con3">
            <img src="../assets/images1/con12.png" @click="conJump(0)">
          </div>
          <div class="con3">
            <img src="../assets/images1/con13.png" style="left: 4.2rem" @click="conJump(2)">
          </div>
          <div class="con3">
            <img src="../assets/images1/con14.png"  style="top: 9.3rem" @click="conJump(1)">
          </div>
          <div class="con3">
            <img src="../assets/images1/con15.png" style="top: 9.3rem;left: 4.2rem" @click="conJump(5)">
          </div>
        </div>

      </div>
    </div>


    <!--小票示例-->
    <div class="xiaopiaoWindow pages" v-show="xiaopiaoFlag" @click="xiaopiaoFlag=false">
      <img src="../assets/images1/xiaopiao.png"/>
    </div>

    <!--规则弹窗-->
    <div class="ruleWrapper pages" v-show="ruleFlag">
      <div class="ruleContent">
        <div class="ruleContent-Text">
          <img src="../assets/images1/rule_text.png"/>
        </div>
        <div class="ruleContent-Content" id="ruleView">
          <img src="../assets/images1/rule_content.png" />
        </div>
        <div class="ruleContent-Return" @click="ruleFlag = false">
          <img src="../assets/images1/btn6.png" style="width: 2.13rem;height: .89rem">
        </div>
      </div>
    </div>

    <!--月份选择-->
    <div>
      <mt-datetime-picker
              ref="picker"
              type="date"
              :startDate="startDates"
              :endDate="endDates"
              @confirm="handleConfirm"
              v-model="pickerValue">
      </mt-datetime-picker>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EXIF from 'exif-js'
import { MessageBox,Toast } from 'mint-ui';
import { mockSubmitInfo } from '../assets/js/config';
import { ISIOS } from '../assets/js/config';
import { KGB } from '../constants/config'
import { obj } from '../assets/js/validation';
import preventScrol from '@/assets/js/preventScroll';
import Scrollbar from 'smooth-scrollbar';
import { getServerTime, dateTimeFormate, dateTimeFormate1 , randomsort, timeOver } from '../assets/js/normalFun';

export default {
  data() {
    return {
      client: '', //sdk
      imgUrlDefault: require('../assets/images/addPic.png'),
      endpoint: '', //oss
      ossInfo: {}, //oss
      ruleStatus: 0, //弹窗出现
      btnStatus: 0, //第一个按钮的不同状态
      btn1Status: 0, //第二个按钮的不同状态
      formData: {
        openid: '',
        username: '',
        phone: null,
        signtime: '', //留资报名时间
        amount: null,
        imgurl: '',
        uploadtime: '',
      },
      mockSubmitInfo: [],
      ruleFlag: false, //规则弹窗显示
      xiaopiaoFlag:false,//小票显示
      submitInfoClickFlag: true, //用户提交信息按钮避免重复点击
      submitInfo2ClickFlag: true, //用户提交晒单信息按钮避免重复点击
      _file: '', //用来暂时存储file的信息
      fileShowFlag: false,

      pickerValue:null,
      selectedValue:null,
      // pickerValue:new Date("2020-08-27"),
      // startDates: new Date("2020-08-27"),
      startDates: new Date("2020-01-01"),
      endDates: new Date("2020-12-31"),
      // endDates: new Date("2020-12-31"),

      KGB:'',
      ISIOS:false,

    };
  },

  methods: {
    /**
     *@Description:获取oss相关的token数据
     *@Param: endpoint imgUrl
     *@return:前者为oss的地址，后者为文件的存储地址
     *@Author: Eddy
     *@time: 2020/6/1 0001 18:29
     */
    async getOssInfo() {
      const res = await this.$api.getOssInfo();
      this.ossInfo = res.data.result.policy;
      this.endpoint = res.data.result.endpoint;
      this.formData.imgurl = res.data.result.url;
      console.log('this.ossInfo', this.ossInfo);
      console.log('this.endpoint', this.endpoint);
      console.log('this.imgUrl', this.formData.imgurl);
    },

    //图片上传修改默认的图片
    picUpload(e) {
      var file = e.target.files[0];

      console.log('图片上传修改默认的图片', e.target.files[0]);

      this.$toast.loading('图片上传中...');

      // 修正图片旋转及压缩，IOS不需要旋转
      if(!ISIOS){
        this.fixImageOrientation(file).then(file2 => {
          this.fileShowFlag = true;
          // this.$refs.imgUrlDefault.src = window.URL.createObjectURL(file2);

          return this.compressImage(file2);
        }).then(file3 => {
          this.$toast.clear();
          this.$refs.imgUrlDefault.src = window.URL.createObjectURL(file3);

        }).then(data => {
          console.log('上传成功');
        }).catch(error => {
          console.error('上传失败')
        })
      }else{
        this.compressImage(file).then(file2 => {
          this.$toast.clear();
          this.fileShowFlag = true;
          this.$refs.imgUrlDefault.src = window.URL.createObjectURL(file2);
        }).then(data => {
          console.log('上传成功');
        }).catch(error => {
          console.error('上传失败')
        })
      }

      //避免重复上传同样的文件不显示
      this.$refs.fileChoose.value = '';
    },

    /**
     * 修正图片旋转角度问题
     * @param {file} 原图片
     * @return {Promise} resolved promise 返回纠正后的新图片
     */
    fixImageOrientation (file) {
      return new Promise((resolve, reject) => {
        // 获取图片
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onerror = () => resolve(file);
        img.onload = () => {
          // 获取图片元数据（EXIF 变量是引入的 exif-js 库暴露的全局变量）
          EXIF.getData(img, function() {
            // 获取图片旋转标志位
            var orientation = EXIF.getTag(this, "Orientation");
            // var orientation = 6;

            console.log("orientation",orientation);
            // 根据旋转角度，在画布上对图片进行旋转

            if (orientation === 3 || orientation === 6 || orientation === 8) {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              switch (orientation) {
                case 3: // 旋转180°
                  canvas.width = img.width;
                  canvas.height = img.height;
                  ctx.rotate((180 * Math.PI) / 180);
                  ctx.drawImage(img, -img.width, -img.height, img.width, img.height);
                  break;
                case 6: // 旋转90°
                  console.log("旋转90°");
                  canvas.width = img.height;
                  canvas.height = img.width;
                  ctx.rotate((90 * Math.PI) / 180);
                  ctx.drawImage(img, 0, -img.height, img.width, img.height);
                  break;
                case 8: // 旋转-90°
                  canvas.width = img.height;
                  canvas.height = img.width;
                  ctx.rotate((-90 * Math.PI) / 180);
                  ctx.drawImage(img, -img.width, 0, img.width, img.height);
                  break;
              }
              // 返回新图片
              canvas.toBlob(file => resolve(file), 'image/jpeg', 0.92);
            } else {
              return resolve(file);
            }
          });
        };
      });

    },

    /**
     * 压缩图片
     * @param {file} 输入图片
     * @returns {Promise} resolved promise 返回压缩后的新图片
     */
    compressImage(file) {
      return new Promise((resolve, reject) => {
        // 获取图片（加载图片是为了获取图片的宽高）
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onerror = error => reject(error);
        img.onload = () => {
          // 画布宽高
          const canvasWidth = document.documentElement.clientWidth * window.devicePixelRatio;
          const canvasHeight = document.documentElement.clientHeight * window.devicePixelRatio;

          // 计算缩放因子
          // 这里我取水平和垂直方向缩放因子较大的作为缩放因子，这样可以保证图片内容全部可见
          const scaleX = canvasWidth / img.width;
          const scaleY = canvasHeight / img.height;
          const scale = Math.min(scaleX, scaleY);

          // 将原始图片按缩放因子缩放后，绘制到画布上
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext("2d");
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          const imageWidth = img.width * scale;
          const imageHeight = img.height * scale;
          const dx = (canvasWidth - imageWidth) / 2;
          const dy = (canvasHeight - imageHeight) / 2;
          ctx.drawImage(img, dx, dy, imageWidth, imageHeight);
          // 导出新图片
          // 指定图片 MIME 类型为 'image/jpeg', 通过 quality 控制导出的图片质量，进行实现图片的压缩
          const quality = 0.92;
          // canvas.toBlob(file => resolve(file), "image/jpeg", quality);
          canvas.toBlob(file => {window._blob = file;resolve(file)}, "image/jpeg", quality);

        };
      });
    },

    /**
     *@Description: 点击立即晒单，图片上传到oss
     *@Param:
     *@return:
     *@Author: Eddy
     *@time: 2020/6/3 0003 11:20
     * */
    async picToOss() {

      if(this.submitInfo2ClickFlag){
        this.submitInfo2ClickFlag = false;
        await this.getOssInfo();
        console.log('imgurlimgurlimgurlimgurl', this.formData.imgurl);
        // var _file = e.target.files[0];
        // var _file = this._file;
        var _file = _blob;
        // console.log('this._file', this._file);

        // 图片通过表单方式上传，所以要声明一个表单对象
        const ossData = new FormData();
        ossData.append('name', _file.name);
        // key就代表文件层级和阿里云上的文件名
        ossData.append('key', this.ossInfo.key);
        ossData.append('policy', this.ossInfo.policy);
        ossData.append('OSSAccessKeyId', this.ossInfo.accessid);
        // 阿里云正常返回204，然后返回信息是空的，想看到返回信息强制让它返回201，返回一个xml文件可以提取有用的信息
        ossData.append('success_action_status', 201);
        ossData.append('signature', this.ossInfo.signature);
        ossData.append('file', _file, _file.name);

        // const instance2 = axios.create({
        //   timeout: 10 * 1000,
        // });
        const instance2 = axios.create({
          timeout: 10 * 1000,
          withCredentials: false,
          ignoreResCode: true,
        });
        instance2
                .post(this.endpoint, ossData)
                .then(() => {
                  console.log('log一下把求求了');
                  getServerTime().then((r) => {
                    this.formData.uploadtime = dateTimeFormate(r);

                    this.client.update(
                            _openid,
                            {
                              amount: this.formData.amount,
                              imgurl: this.formData.imgurl,
                              buytime:this.selectedValue,
                              uploadtime: this.formData.uploadtime,
                            },
                            (err, res) => {
                              console.log('err==', err);
                              console.log('res===', res, {
                                amount: this.formData.amount,
                                imgurl: this.formData.imgurl,
                                uploadtime: this.formData.uploadtime,
                              });
                              if (res) {
                                // alert(this.ossInfo.url);
                                console.log('向后台提交第二次用户信息成功'),
                                        (this.submitInfo2ClickFlag = true),
                                        (this.btn1Status = 1),
                                        (this.ruleStatus = 2);
                              }
                            }
                    );
                  });
                })
                .catch((err) => {
                  console.log('baocuole', err);
                  MessageBox.alert('图片上传失败，请重新上传~~', '提示');
                  this.submitInfo2ClickFlag = true;
                })
                .finally();
      }

    },

    /**
     *@Description: 进来的时候查看当前用户是否提交过信息
     *@Param: submitInfoFlag
     *@return: Boolean
     *@Author: Eddy
     *@time: 2020/5/15 0015 14:30
     */
    checkSubmitInfo() {
      window._setTIMEOUT = setTimeout(() => {
        window.clearTimeout(_setTIMEOUT);

        const userStoreKey = `mediaAutumn_user_store_key`;

        //for dev
        window._openid = JSON.parse(localStorage.getItem(userStoreKey)).openid;

        //for test
        // window._openid = 'ljs0005';

        console.log('~~~_openid~~：', _openid);

        this.client = new DBCURD('curd_media_8', { field: 'openid' });
        console.log(this.client);

        this.client.get(_openid, (err, res) => {
          console.log('res', res);
          obj.emptyObj(res) ? (this.btnStatus = 0) : (this.btnStatus = 1);
          if (!obj.emptyObj(res)) {
            this.formData.username = res.username;
            this.formData.phone = res.phone;

            if (obj.emptyObj(res.amount)) {
              this.btn1Status = 0;
            } else {
              this.formData.amount = res.amount;
              this.imgUrlDefault = res.imgurl;
              this.selectedValue = res.buytime;
              this.fileShowFlag = true;
              this.btn1Status = 1;
            }
          }

          this.checkEnd();
        });
      }, 500);
    },



    /**
     * 点击提交按钮
     * */
    submitInfoClick() {
      if (!this.formData.username) {
        MessageBox.alert('请填写您的姓名~~', '提示');
      } else if (!this.formData.phone) {
        MessageBox.alert('请填写您的手机号~~', '提示');
      } else if (!obj.telCheck(this.formData.phone)) {
        MessageBox.alert('请正确输入11位手机号码哦～', '提示');
      } else {
        if (this.submitInfoClickFlag) {
          this.submitInfoClickFlag = false;

          getServerTime().then((r) => {
            this.formData.signtime = dateTimeFormate(r);

            this.client.create(
              {
                openid: _openid,
                username: this.formData.username,
                phone: this.formData.phone,
                signtime: this.formData.signtime,
              },
              (err, res) => {
                if (res) {
                  console.log('向后台提交用户信息成功'),
                    console.log(
                      'this.formData.signtime',
                      this.formData.signtime
                    ),
                    (this.submitInfoClickFlag = true),
                    (this.btnStatus = 1),
                    (this.ruleStatus = 1);
                }
              }
            );
          });
        }
      }
    },

    /**
     * 点击第二个提交按钮
     * */
    async submitInfo2Click() {
      if(this.btnStatus === 0){
        MessageBox.alert('请先登记您的信息~~','提示');
      }else{
        if(!this.formData.amount){
          MessageBox.alert('请填写您的购机金额~~','提示');
        }else if(!this.selectedValue){
          MessageBox.alert('请填写您的购机时间~~','提示');
        }else if(this.fileShowFlag == false){
          MessageBox.alert('请上传您的购机小票~~','提示');
        }else{
          console.log('submitInfo2Click imgurl', this.formData.imgurl);
          await this.picToOss();

        };
     }
    },

    phoneCheck() {
      window.scrollTo(0, 0);
      if (!obj.telCheck(this.formData.phone)) {
        MessageBox.alert('请正确输入11位手机号码哦～', '提示');
      }
    },

    _initScroll() {
      var _view = document.getElementById('view');
      var _view1 = document.getElementById('ruleView');
      var _view2 = document.getElementById('window');

      Scrollbar.init(_view);
      Scrollbar.init(_view1);
      Scrollbar.init(_view2);

      document.getElementsByClassName('scrollbar-track-y')[0].style.width = 0;
      document.getElementsByClassName('scrollbar-track-y')[1].style.width = 0;
      document.getElementsByClassName('scrollbar-track-y')[2].style.width = 0;
    },

    deletePicHandler() {
      this.fileShowFlag = false;
      // this._file = '';
    },

    //点击复制按钮
    btnHandler(){
      Toast({
        message: '复制成功，请打开“淘宝APP”领取',
        duration: 1500
      });
      let clipboard = new this.clipboard(".cobyText");
    },

    //产品跳转
    conJump(status){
      switch (status) {
        case 0 :
          window.location.href = "https://u.jd.com/Zf0VsU";break;
        case 1 :
          window.location.href = "https://u.jd.com/hV6RQ9";break;
        case 2 :
          window.location.href = "https://u.jd.com/HHYjHD";break;
        case 3 :
          window.location.href = "https://u.jd.com/I0qeQv";break;
        case 4 :
          window.location.href = "https://u.jd.com/f6NGTN";break;
        case 5 :
          window.location.href = "https://u.jd.com/K5dif2";break;
        case 6 :
          window.location.href = "https://u.jd.com/1Rtvc6";break;
        case 7 :
          window.location.href = "https://u.jd.com/puVSor";break;
        case 8 :
          window.location.href = "https://coupon.m.jd.com/coupons/show.action?key=04f279dcb36b4c1db7158be20c6af1bc&roleId=36923684&to=https://mall.jd.com/index-1000282702.html";break;
        case 9 :
          window.location.href = "https://coupon.m.jd.com/coupons/show.action?key=8274f5b3c6ed48939de9158b1e5a0cf8&roleId=37067577&to=https://mall.jd.com/index-1000282702.html";break;
        case 10:
          window.location.href = "http://s.midea.com/s/qfMi0KJ";break;
        default:
          break;
      }
    },

    //日期选择出现
    dateShow(){

      if(this.btn1Status != 1){
        this.$refs.picker.open();
      }
    },

    handleConfirm(){
      if (!this.pickerValue) {
        console.log("----s");
        this.selectedValue = dateTimeFormate1(this.startDates);
      }else{
        this.selectedValue = dateTimeFormate1(this.pickerValue);
      }
      console.log("点击confirm",this.selectedValue);
    },

    /**
     *   判断活动过期
     * */
    checkEnd(){
      //获取服务器时间
      getServerTime().then(r=>{
        var overTime = '2020-09-30 23:59:59';
        if(timeOver(dateTimeFormate(r),overTime)){
          console.log("超时");
          this.btnStatus = this.btn1Status = 2;
        }else{
          console.log("没有超时");
        }

      });
    },

  },

  created() {
    preventScrol();
    this.checkSubmitInfo();
    // this.getOssInfo();
    // this.checkEnd();

    KGB > 1.69?this.KGB = true: this.KGB = false;

    this.ISIOS = ISIOS;


  },

  mounted() {
    this._initScroll();



    var ua = navigator.userAgent.toLowerCase();
    // console.log("ua---",ua);
    var isIos = (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1);
    var isMi = ua.indexOf('mi') != -1;
    if (isIos || isMi) {
      document.getElementById("fileAAA").removeAttribute("capture");
    };


  },


};
</script>

<style lang="stylus">

.pages
    position absolute
    top 0
    width 100%
    height 100%
    overflow hidden

input
    width: 100%
    font-size:.3rem
    color:black

.mint-msgbox-btn
    font-size: 20px !important

.outSideWrapper
    overflow-y auto
    .longWrapper
        position absolute
        top 0
        background url("~@/assets/images1/bg.jpg") no-repeat
        width 100%
        height 48.1rem
        background-size 100% 100%
        overflow: hidden;
        .formData
            position: relative
            top: 10.45rem
            left: .55rem
            font-size .3rem
            margin-left: .6rem
            line-height: 0
        .submitBtn
            position: relative
            margin: 10.8rem auto 0 auto
        .question
            position absolute
            top: 41.1rem;
            left: 2.7rem;
            width .3rem
            height .3rem
            img
              width .3rem
              height .3rem
        .fileWrapper
            position relative
            top: 28.45rem
            width 1.44rem
            height 1.44rem
            left: .8rem
            .fileChoose
                position absolute
                width 1.44rem
                height 1.44rem
                opacity 0
            .fileSelectPicWrapper
                position absolute
                left 2rem
                top 0
                .fileSelectPic
                    border-radius .2rem
                .deletePic
                    position: absolute
                    left: 1.2rem
                    top: -.1rem
                    width .38rem
                    height .39rem
            img
                width 1.44rem
                height 1.44rem

        .con1
          position absolute
          top 15.03rem
          left .3rem
          width 6.98rem
          height 3.75rem
          margin: 0 auto;
          img
            width 6.98rem
            height 3.75rem
          .conBtn
            position absolute
            left: 2.1rem
            top: 2.32rem
            width 3.03rem
            height .59rem
            animation-iteration-count: infinite
          .imgWrapper
            position: absolute;
            top: 0.2rem;
            left: .4rem;
            background: #f00;
            width: 3rem;
            height: 2.7rem;
            z-index: 2;
            opacity:0;
      .ruleBtn
            background url("../assets/images/rule_btn.png") no-repeat
            background-size 100%
            width 3.14rem
            height .37rem
            position relative
            /*margin 12.4rem auto 0 auto*/
            margin 18.9rem auto 0 auto

.xiaopiaoWindow
   background:rgba(0, 0, 0, 0.75);
   img
     position relative
     top: 2%
     width: 7rem
     height: 11.77rem

.submitWindow
    background:rgba(0, 0, 0, 0.75);
    .closeBtn
      width: 0.54rem;
      height: 0.54rem;
      position: absolute;
      top: .1rem;
      right: 0.2rem;
      z-index: 2;
    img
        position: relative
        top:2rem
        width: 6.82rem
        height: 7.51rem
    .dis
      position absolute
      top 2rem
      left 1.1rem
      img
        width 2.27rem
        height 1.08rem
    .dis1
      left 4.1rem

    .con2
        position relative
        margin  0 auto
        top -12.85rem
        img
          width 6.37rem
          height 2rem
  .con3
    img
      width: 2.6rem;
      height: 2.74rem;
      position: absolute;
      top: 6.2rem;
      left: 0.8rem;


.ruleWrapper
    background:rgba(0, 0, 0, 0.75);
    .ruleContent
        position: relative
        margin 0 auto
        top:1rem
        background white
        width: 6.8rem
        height: 9.5rem
        border-radius .2rem
        overflow hidden
        &-Text
            position relative
            top -.2rem
            img
                text-align center
                width 2.22rem
                height .54rem
        &-Content
            overflow-y auto
            height 6.8rem
            img
                width 6.54rem
                height 22.21rem
        &-Return
            position: relative
            margin: .2rem auto 0 auto

</style>
